/// <amd-module name="WorkItemsHub/Components/Cells/WorkItemCommentCountCell" />
import * as React from "react";
import * as TooltipEx from "VSSUI/TooltipEx";
import * as Resources from "WorkItemsHub/Resources";

import * as Utils_String from "VSS/Core/Util/String";

export interface ICommentCountCellOptions {
    workItemCommentCount: string
}

const MAX_COUNT = 99;
const TRUNC_COUNT = Utils_String.format(Resources.WorkItemsHubTruncatedCommentCount, MAX_COUNT);

export function createWorkItemCommentCountCell(options: ICommentCountCellOptions): JSX.Element {
    var count = Number(options.workItemCommentCount) > MAX_COUNT ? TRUNC_COUNT : options.workItemCommentCount;

    return (
        <TooltipEx.Tooltip text={count} overflowOnly={true}>
            <div className="work-item-comment-count-cell">
                <span className="bowtie-icon bowtie-comment-discussion work-item-comment-count-icon" />
                <span>{count}</span>
            </div>
        </TooltipEx.Tooltip>
    );
}
